import logger from '@piconetworks/logger'

const pathname = (window.location.pathname || '').split('/')[1] || 'unknown'
logger.setContext({ service: `${process.env.STAGE}-gadget-${pathname}` })

export default logger
